export enum OptionCode {
    SMART_TV = 'SMART_TV',
    I_TV_DIGITALE = 'I_TV_DIGITALE',
    PACK_CYBER_HOME = 'PACK_CYBER_HOME',
    PACK_CYBER_MOBILE = 'PACK_CYBER_MOBILE',
}
